import React from 'react';
import useDeviceType from 'hooks/useDeviceType';
import { TLoginLayoutProps } from './type';
import { SPage } from './style';
import WebLayout from './components/WebLayout';

const LoginLayout = ({ children }: TLoginLayoutProps) => {
  const { isMobile } = useDeviceType();

  return isMobile ? (
    <SPage>{children}</SPage>
  ) : (
    <WebLayout>{children}</WebLayout>
  );
};

export default LoginLayout;
